import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ce3206f8")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_arrowSVG = _resolveComponent("arrowSVG")!

  return (_openBlock(), _createBlock("div", {
    class: "accordion-title",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateToggle && _ctx.updateToggle(...args)))
  }, [
    _createVNode("h2", null, _toDisplayString(_ctx.title), 1),
    _createVNode("button", {
      class: [{ 'active': _ctx.toggle }, "button-toggle"],
      "aria-expanded": _ctx.toggle
    }, [
      _createVNode(_component_arrowSVG)
    ], 10, ["aria-expanded"])
  ]))
})